// Registry of in-flight design changes. Each change is gated by useDesignChange(id) so the
// /design-review page can render the same route with and without it. Once a change is
// approved or rejected, delete the losing branch at its call sites and remove it from here.

export type DesignChange = {
  id: string;
  title: string;
  summary: string;
  // Route templates; `:projectId` is filled with the reviewer's first project.
  routes: string[];
};

export const designChanges: DesignChange[] = [
  {
    id: "chart-editor-header",
    title: "Chart editor header",
    summary:
      "Breadcrumb bar shows 'Board › Chart' with a back arrow instead of a lone grey board name. Chart title uses the same weight as board titles, the page padding is tighter, and the 'Computed Xs ago' line sits with the date range instead of floating.",
    routes: ["/p/:projectId/chart"],
  },
  {
    id: "chart-data-table",
    title: "Chart data table",
    summary:
      "The table under a chart uses the UI font with tabular numbers instead of monospace, gets a quieter header row, right-aligned numbers, and sits in a bordered card.",
    routes: ["/p/:projectId/chart"],
  },
  {
    id: "line-charts",
    title: "Line chart styling",
    summary:
      "Smooth (monotone, no overshoot) curves, a faint gradient fill under single-series lines, softer gridlines, and a ringed point on hover. Applies to dashboard cards and the editor.",
    routes: ["/p/:projectId", "/p/:projectId/chart"],
  },
  {
    id: "event-properties",
    title: "Event properties page",
    summary:
      "Adds an 'Events › EventName' breadcrumb and heading (the page never showed which event you were on), puts TTL settings and the property list in matching cards in a centered column, and makes Sync Properties a normal secondary button.",
    routes: ["/p/:projectId/events/Purchase/properties"],
  },
  {
    id: "dropdown-menus",
    title: "Dropdown menus",
    summary:
      "Menus get a darker surface with a stronger shadow, compact 32px rows, and the selected option shows a check with a subtle highlight instead of a solid blue fill.",
    routes: ["/p/:projectId", "/p/:projectId/chart"],
  },
  {
    id: "tax-form",
    title: "State tax form",
    summary:
      "Period/year/quarter/profit controls share one 36px height and align with the Calculate button; labels match the rest of the app instead of extra-wide letter spacing.",
    routes: ["/p/:projectId/tax-estimates"],
  },
  {
    id: "not-found",
    title: "404 and error pages",
    summary:
      "The bare '404 - Page not found' text on black becomes a branded page with the Voidpulse mark, a short explanation, and a button back to your dashboard. The route error screen gets the same treatment.",
    routes: ["/this-page-does-not-exist"],
  },
];

export const designChangeIds = designChanges.map((c) => c.id);
